<template>
  <div class="p-formgrid">
      <div class="p-field p-grid" style="padding-top: 15px;">
            <label class="p-col-fixed txt-right">Tên nhóm quyền (*)</label>
            <div class="p-col">
              <InputText v-model="name"  id="name" type="text" class="p-col-width" placeholder="Nhập tên nhóm quyền" />
              <small
                v-if="validationErrors && validationErrors['name']"
                class="p-invalid"
              >{{validationErrors['name']}}</small>
            </div>
        </div>
        <div class="p-field p-grid" >
            <label class="p-col-fixed txt-right">Chọn quyền :</label>
        </div>
          <div class="p-field p-grid" >
            <div class="p-col-3" style="margin-left: 10px; padding-top: 5px; border: 1px solid black; font-weight: bold;">Quyền</div>
            <div class="p-col-1" style="text-align: center; font-weight: bold; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              <span style="display: block">Tất cả</span>
              <input style="margin-top: 5px;" type="checkbox" v-model="isAllRole" :binary="true" @change="CheckboxALlRole()" />
            </div>
            <div class="p-col-1" style="text-align: center; font-weight: bold; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">Chi tiết</div>
            <div class="p-col-1" style="text-align: center; font-weight: bold; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">Xem</div>
            <div class="p-col-1" style="text-align: center; font-weight: bold; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">Thêm</div>
            <div class="p-col-1" style="text-align: center; font-weight: bold; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">Sửa</div>
            <div class="p-col-1" style="text-align: center; font-weight: bold; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">Xóa</div>
            <div class="p-col-1" style="text-align: center; font-weight: bold; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">Xuất</div>
            <div class="p-col-1" style="text-align: center; font-weight: bold; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">Xóa nhóm văn bản</div>
          </div>
          <div v-for="per in ListPermission" :key="per.id" class="p-field p-grid" >
            <div class="p-col-3" style="margin-top: -16px; padding-bottom: 10px; margin-left: 10px; padding-top: 10px; border-right: 1px solid black; border-bottom: 1px solid black; border-left: 1px solid black;">{{per.name}}</div>
            <div class="p-col-1" style="margin-top: -16px; padding-bottom: 10px; text-align: center; border-bottom: 1px solid black; border-right: 1px solid black;">
              <input type="checkbox" v-bind:checked="per.all" v-model="per.all" :binary="true" @change="CheckboxChangeAll(per)"/>
            </div> 
            <div class="p-col-1" style="margin-top: -16px; padding-bottom: 10px; text-align: center; border-bottom: 1px solid black; border-right: 1px solid black;">
              <input v-if="per.view_disabled == false" type="checkbox" v-bind:checked="per.view" v-model="per.view" :binary="true" @change="CheckboxChange(per)"/>
              <input v-else type="hidden" v-bind:checked="per.view" v-model="per.view" :binary="true" />
            </div>
            <div class="p-col-1" style="margin-top: -16px; padding-bottom: 10px; text-align: center; border-bottom: 1px solid black; border-right: 1px solid black;">
              <input v-if="per.list_disabled == false" type="checkbox" v-bind:checked="per.list" v-model="per.list" :binary="true" @change="CheckboxChange(per)" />
              <input v-else type="hidden" v-bind:checked="per.list" v-model="per.list" :binary="true" />
            </div>
            <div class="p-col-1" style="margin-top: -16px; padding-bottom: 10px; text-align: center; border-bottom: 1px solid black; border-right: 1px solid black;">
              <input v-if="per.add_disabled == false" type="checkbox" v-bind:checked="per.add" v-model="per.add" :binary="true" @change="CheckboxChange(per)" />
              <input v-else type="hidden" v-bind:checked="per.add" v-model="per.add" :binary="true" />
            </div>
            <div class="p-col-1" style="margin-top: -16px; padding-bottom: 10px; text-align: center; border-bottom: 1px solid black; border-right: 1px solid black;">
              <input v-if="per.edit_disabled == false" type="checkbox" v-bind:checked="per.edit" v-model="per.edit" :binary="true" @change="CheckboxChange(per)" />
              <input v-else type="hidden" v-bind:checked="per.edit" v-model="per.edit" :binary="true" />
            </div>
            <div class="p-col-1" style="margin-top: -16px; padding-bottom: 10px; text-align: center; border-bottom: 1px solid black; border-right: 1px solid black;">
              <input v-if="per.delete_disabled == false" type="checkbox" v-bind:checked="per.delete" v-model="per.delete" :binary="true" @change="CheckboxChange(per)"/>
              <input v-else type="hidden" v-bind:checked="per.delete" v-model="per.delete" :binary="true" />
            </div>
            <div class="p-col-1" style="margin-top: -16px; padding-bottom: 10px; text-align: center; border-bottom: 1px solid black; border-right: 1px solid black;">
              <input v-if="per.export_disabled == false" type="checkbox" v-bind:checked="per.export" v-model="per.export" :binary="true" @change="CheckboxChange(per)" />
              <input v-else type="hidden" v-bind:checked="per.export" v-model="per.export" :binary="true" />
            </div>
            <div class="p-col-1" style="margin-top: -16px; padding-bottom: 10px; text-align: center; border-bottom: 1px solid black; border-right: 1px solid black;">
              <input v-if="per.delete_group_disabled == false" type="checkbox" v-bind:checked="per.delete_group" v-model="per.delete_group" :binary="true" @change="CheckboxChange(per)" />
              <input v-else type="hidden" v-bind:checked="per.delete_group" v-model="per.delete_group" :binary="true" />
            </div>
          </div>

    <Toolbar class="fixed-bottom-toolbar">
      <template slot="right">
        <Button
          label="Quay lại"
          @click="backToList()"
          class="p-button-warning"
        />
        <Button
          v-if="mode == 'edit'"
          :label="'Lưu thay đổi'"
          @click="saveData()"
          class="p-button-success"
        />
        <Button
          v-else
          :label="'Tạo phân quyền'"
          @click="saveData()"
          class="p-button-success"
        />
      </template>
    </Toolbar>
  </div>
</template>

<script>
// import DataServices from '@/core/DataServices'
import gql from "graphql-tag";
export default {
  props: {
    mode: String,
    model: Object,
  },
  data() {
    return {
      validationErrors: {},
      formMode: this.mode,
      ListPermission: [],
      ListGroupPer: [],
      name: '',
      group_permission_id: null,
      isAllRole:false
    }
  },
  mounted() {
    if (this.$route.params.id !== undefined) {
      this.group_permission_id = this.$route.params.id
      this.getDataId(this.$route.params.id);
      this.formMode = "edit"
    }else{
      this.formMode = "add"
      this.getData()
    }
    // console.log('this.group_permission_id', this.group_permission_id)
  },
  methods: {
    backToList() {
      this.$emit('back');
    },
    async getDataId(id){
      let query = `
        query MyQuery($id: Int) {
          group_permission(where: {id: {_eq: $id}}) {
            id
            name
            group_permission_details(order_by: {permission_id: asc}) {
              add
              delete
              edit
              export
              list
              view
              delete_group
              permission_id
              permission {
                name
                key
              }
            }
          }
        }
      `
      await this.$apollo.query({
          query: gql(query),
          variables: {
            id: id
          }
        }).then((res) => {
          if(res.data.group_permission.length > 0){
            this.ListGroupPer = res.data.group_permission
            var data_custom = []
            if (this.ListGroupPer && this.ListGroupPer[0].group_permission_details) {
              for (let i = 0; i < this.ListGroupPer[0].group_permission_details.length; i++) {
                const e = this.ListGroupPer[0].group_permission_details[i];
                e.all = false;
                e.view_disabled = false;
                e.list_disabled = false;
                e.add_disabled = false;
                e.edit_disabled = false;
                e.delete_disabled = false;
                e.export_disabled = false;
                e.delete_group_disabled = true;
                if(e.permission.key == "insert_document"){
                  if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true && e.export == true){
                    e.all = true;
                  }
                }else if(e.permission.key == "list_document"){
                  if(e.view == true && e.list == true && e.edit == true && e.delete == true){
                    e.all = true;
                  }
                  e.add_disabled = true;
                  e.export_disabled = true;
                  e.delete_group_disabled = false;
                }else if(e.permission.key == "detail_document"){
                  if(e.view == true && e.list == true && e.export == true){
                    e.all = true;
                  }
                  e.add_disabled = true;
                  e.edit_disabled = true;
                  e.delete_disabled = true;
                }else if(e.permission.key == "court_document"){
                  if(e.view == true && e.list == true && e.edit == true && e.export == true){
                    e.all = true;
                  }
                  e.add_disabled = true;
                  // e.edit_disabled = true;
                  e.delete_disabled = true;
                }else if(e.permission.key == "confirm_salary_document"){
                  if(e.view == true && e.list == true && e.edit== true){
                    e.all = true;
                  }
                  e.add_disabled = true;
                  // e.edit_disabled = true;
                  e.delete_disabled = true;
                  //e.export_disabled = true;
                }else if(e.permission.key == "list_document_province"){
                  if(e.view == true && e.list == true && e.export == true){
                    e.all = true;
                  }
                  e.add_disabled = true;
                  e.edit_disabled = true;
                  e.delete_disabled = true;
                  // e.export_disabled = true;
                }else if(e.permission.key == "employee_payroll"){
                  if(e.view == true && e.list == true){
                    e.all = true;
                  }
                  e.add_disabled = true;
                  e.edit_disabled = true;
                  e.delete_disabled = true;
                }else if(e.permission.key == "organ_pricelist"){
                  if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
                    e.all = true;
                  }
                  e.export_disabled = true;
                }else if(e.permission.key == "organ_pricelist_province"){
                  if(e.view == true && e.list == true  && e.edit == true){
                    e.all = true;
                  }
                  e.add_disabled = true;
                  e.delete_disabled = true;
                  e.export_disabled = true;
                }else if(e.permission.key == "salary_pricelist"){
                  if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
                    e.all = true;
                  }
                  e.export_disabled = true;
                }else if(e.permission.key == "salary_pricelist_province"){
                  if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
                    e.all = true;
                  }
                  e.export_disabled = true;
                }else if(e.permission.key == "holiday_setting"){
                  if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
                    e.all = true;
                  }
                  e.export_disabled = true;
                }else if(e.permission.key == "delay_document_setting"){
                  if(e.view == true && e.add == true){
                    e.all = true;
                  }
                  e.edit_disabled = true;
                  e.list_disabled = true;
                  e.export_disabled = true;
                  e.delete_disabled = true;
                }else if(e.permission.key == "report_late_done"){
                  if(e.view == true && e.list == true && e.edit == true && e.export == true){
                    e.all = true;
                  }
                  e.add_disabled = true;
                  // e.edit_disabled = true;
                  e.delete_disabled = true;
                }else if(e.permission.key == "report_late_undone"){
                  if(e.view == true && e.list == true && e.edit == true && e.export == true){
                    e.all = true;
                  }
                  e.add_disabled = true;
                  // e.edit_disabled = true;
                  e.delete_disabled = true;
                }else if(e.permission.key == "report_compare"){
                  if(e.view == true && e.list == true && e.edit == true && e.export == true){
                    e.all = true;
                  }
                  e.add_disabled = true;
                  // e.edit_disabled = true;
                  e.delete_disabled = true;
                }else if(e.permission.key == "push_notification"){
                  if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
                    e.all = true;
                  }
                  // e.edit_disabled = true;
                  // e.delete_disabled = true;
                  e.export_disabled = true;
                }else if(e.permission.key == "list_coordinator"){
                  if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
                    e.all = true;
                  }
                  e.export_disabled = true;
                }
                else if(e.permission.key == "list_court_account"){
                  if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
                    e.all = true;
                  }
                  e.export_disabled = true;
                }
                else if(e.permission.key == "list_circulator"){
                  if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
                    e.all = true;
                  }
                  e.export_disabled = true;
                }else if(e.permission.key == "list_office"){
                  if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
                    e.all = true;
                  }
                  e.export_disabled = true;
                }else if(e.permission.key == "list_area"){
                  if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
                    e.all = true;
                  }
                  e.export_disabled = true;
                }else if(e.permission.key == "list_organization"){
                  if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
                    e.all = true;
                  }
                  e.export_disabled = true;
                }else if(e.permission.key == "list_affiliate_office"){
                  if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
                    e.all = true;
                  }
                  e.export_disabled = true;
                } else if(e.permission.key == "report_compare_agency"){
                  if(e.view == true && e.list == true && e.edit == true && e.export == true){
                    e.all = true;
                  }
                  e.add_disabled = true;
                  e.edit_disabled = true;
                  e.delete_disabled = true;
                }
                else if(e.permission.key == "report_docs_tdv"){
                  if(e.view == true && e.list == true && e.edit == true && e.export == true){
                    e.all = true;
                  }
                  e.add_disabled = true;
                  e.edit_disabled = true;
                  e.delete_disabled = true;
                }
                else if(e.permission.key == "report_general_employee_inventory"){
                  if(e.view == true && e.list == true && e.edit == true && e.export == true){
                    e.all = true;
                  }
                  e.add_disabled = true;
                  e.edit_disabled = true;
                  e.delete_disabled = true;
                }
                else if(e.permission.key == "edit_document_after_salary"){
                  if(e.edit == true){
                    e.all = true;
                  }
                  e.view_disabled = true;
                  e.list_disabled = true;
                  e.add_disabled = true;
                  e.delete_disabled = true;
                  e.export_disabled = true;
                }
                e.name = e.permission.name
                e.id = e.permission_id
                data_custom.push(e);
              }
            }
            this.ListPermission = data_custom
            this.name = this.ListGroupPer[0].name
            // console.log('permission', this.ListPermission)
          }
        })
    },
    async getData(){
      let query = `
        query MyQuery {
          permission (order_by: {id: asc}){
            name
            id
            key
          }
        }
      `;
      await this.$apollo.query({
        query: gql(query),
      }).then((res) => {
        if(res.data.permission.length > 0){
          this.ListPermission = res.data.permission
          // console.log("this.ListPermission",this.ListPermission)
          let tmp = [];
          for (let i = 0; i < this.ListPermission.length; i++) {
            const e = this.ListPermission[i];
            e.all = false
            e.view = false
            e.list = false
            e.add = false
            e.edit = false
            e.delete = false
            e.export = false
            e.delete_group = false
            e.view_disabled = false;
            e.list_disabled = false;
            e.add_disabled = false;
            e.edit_disabled = false;
            e.delete_disabled = false;
            e.export_disabled = false;
            e.delete_group_disabled = true;
            if(e.key == "list_document"){
              e.export_disabled = true;
              e.add_disabled = true;
              e.delete_group_disabled = false;
            }else if(e.key == "detail_document"){
              e.add_disabled = true;
              e.edit_disabled = true;
              e.delete_disabled = true;
            }else if(e.key == "court_document"){
              e.add_disabled = true;
              // e.edit_disabled = true;
              e.delete_disabled = true;
            }else if(e.key == "confirm_salary_document"){
              e.add_disabled = true;
              // e.edit_disabled = true;
              e.delete_disabled = true;
              e.export_disabled = true;
            }else if(e.key == "list_document_province"){
              e.add_disabled = true;
              e.edit_disabled = true;
              e.delete_disabled = true;
              // e.export_disabled = true;
            }else if(e.key == "employee_payroll"){
              e.add_disabled = true;
              e.edit_disabled = true;
              e.delete_disabled = true;
              // e.export_disabled = true;
            }else if(e.key == "organ_pricelist"){
              e.export_disabled = true;
            }else if(e.key == "organ_pricelist_province"){
              e.add_disabled = true;
              e.delete_disabled = true;
              e.export_disabled = true;
            }else if(e.key == "salary_pricelist"){
              e.export_disabled = true;
            }else if(e.key == "salary_pricelist_province"){
              e.export_disabled = true;
            }else if(e.key == "holiday_setting"){
              e.export_disabled = true;
            }else if(e.key == "delay_document_setting"){
              e.list_disabled = true;
              e.edit_disabled = true;
              e.export_disabled = true;
              e.delete_disabled = true;
            }else if(e.key == "report_late_done"){
              e.add_disabled = true;
              // e.edit_disabled = true;
              e.delete_disabled = true;
            }else if(e.key == "report_late_undone"){
              e.add_disabled = true;
              // e.edit_disabled = true;
              e.delete_disabled = true;
            }else if(e.key == "report_compare"){
              e.add_disabled = true;
              // e.edit_disabled = true;
              e.delete_disabled = true;
            }else if(e.key == "push_notification"){
              // e.edit_disabled = true;
              // e.delete_disabled = true;
              e.export_disabled = true;
            }else if(e.key == "list_coordinator"){
              e.export_disabled = true;
            }
            else if(e.key == "list_court_account"){
              e.export_disabled = true;
            }
            else if(e.key == "list_circulator"){
              e.export_disabled = true;
            }else if(e.key == "list_office"){
              e.export_disabled = true;
            }else if(e.key == "list_area"){
              e.export_disabled = true;
            }else if(e.key == "list_organization"){
              e.export_disabled = true;
            }else if(e.key == "list_affiliate_office"){
              e.export_disabled = true;
            }
            else if(e.key == "report_compare_agency"){
              e.add_disabled = true;
              e.edit_disabled = true;
              e.delete_disabled = true;
            }
            else if(e.key == "report_general_employee_inventory"){
              e.add_disabled = true;
              e.edit_disabled = true;
              e.delete_disabled = true;
            }
            else if(e.key == "report_docs_tdv"){
              e.add_disabled = true;
              e.edit_disabled = true;
              e.delete_disabled = true;
            }
            else if(e.key == "edit_document_after_salary"){
              e.view_disabled = true;
              e.list_disabled = true;
              e.add_disabled = true;
              e.delete_disabled = true;
              e.export_disabled = true;
            }
            tmp.push(e);
          }
          this.ListPermission = tmp;
        }
      })
    },
    CheckboxChange(data) {
      let tmp = []
      // console.log('change', data)
      for (let i = 0; i < this.ListPermission.length; i++) {
        const e = this.ListPermission[i];
        if (e.id == data.id) {
          let check_all = false;
          let permission_key = '';
          if(this.formMode == "edit"){
            permission_key = e.permission.key;
          }else{
            permission_key = e.key;
          }
          if(permission_key == "insert_document"){
            if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true && e.export == true){
              check_all = true;
            }
          }else if(permission_key == "list_document"){
            if(e.view == true && e.list == true && e.edit == true && e.delete == true && e.delete_group == true){
             check_all = true;
            }
          }else if(permission_key == "detail_document"){
            if(e.view == true && e.list == true && e.export == true){
              check_all = true;
            }
          }else if(permission_key == "court_document"){
            if(e.view == true && e.list == true && e.edit == true && e.export == true){
              check_all = true;
            }
          }else if(permission_key == "confirm_salary_document"){
            if(e.view == true && e.list == true && e.edit == true){
              check_all = true;
            }
          }else if(permission_key == "list_document_province"){
            if(e.view == true && e.list == true && e.export == true){
              check_all = true;
            }
          }else if(permission_key == "employee_payroll"){
            if(e.view == true && e.list == true && e.export == true){
              check_all = true;
            }
          }else if(permission_key == "organ_pricelist"){
            if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
              check_all = true;
            }
          }else if(permission_key == "organ_pricelist_province"){
            if(e.view == true && e.list == true  && e.edit == true){
              check_all = true;
            }
          }else if(permission_key == "salary_pricelist"){
            if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
              check_all = true;
            }
          }else if(permission_key == "salary_pricelist_province"){
            if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
              check_all = true;
            }
          }else if(permission_key == "holiday_setting"){
            if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
              check_all = true;
            }
          }else if(permission_key == "delay_document_setting"){
            if(e.view == true && e.add == true){
              check_all = true;
            }
          }else if(permission_key == "report_late_done"){
            if(e.view == true && e.list == true && e.edit == true && e.export == true){
              check_all = true;
            }
          }else if(permission_key == "report_late_undone"){
            if(e.view == true && e.list == true && e.edit == true && e.export == true){
              check_all = true;
            }
          }else if(permission_key == "report_compare"){
            if(e.view == true && e.list == true && e.edit == true && e.export == true){
              check_all = true;
            }
          }else if(permission_key == "push_notification"){
            if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
              check_all = true;
            }
          }else if(permission_key == "list_coordinator"){
            if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
              check_all = true;
            }
          }else if(permission_key == "list_circulator"){
            if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
              check_all = true;
            }
          }else if(permission_key == "list_office"){
            if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
              check_all = true;
            }
          }else if(permission_key == "list_area"){
            if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
              check_all = true;
            }
          }else if(permission_key == "list_organization"){
            if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
              check_all = true;
            }
          }else if(permission_key == "list_affiliate_office"){
            if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
              check_all = true;
            }
          }
          e.all = check_all;
          data = e
        }
        tmp.push(e);
      }
      this.ListPermission = tmp;

    },
    CheckboxChangeAll(data) {
      let tmp = []
      for (let i = 0; i < this.ListPermission.length; i++) {
        const e = this.ListPermission[i];
        if (e.id == data.id) {
          if(e.all == true){
            e.view = true
            e.list = true
            e.add = true
            e.edit = true
            e.delete = true
            e.export = true
            e.delete_group = true
          }else{
            e.view = false
            e.list = false
            e.add = false
            e.edit = false
            e.delete = false
            e.delete_group = false
          }
          data = e
        }
        tmp.push(e);
      }
      this.ListPermission = tmp;
    },
    CheckboxALlRole() {
      let tmp = []
      for (let i = 0; i < this.ListPermission.length; i++) {
        const e = this.ListPermission[i];
          if(this.isAllRole ==true){
            e.all = true
            e.view = true
            e.list = true
            e.add = true
            e.edit = true
            e.delete = true
            e.export = true
          }else{
            e.all = false
            e.view = false
            e.list = false
            e.add = false
            e.edit = false
            e.delete = false
            e.export = false
          }
        tmp.push(e);
      }
      this.ListPermission = tmp;
    },
    async validateData() {
      console.log('-------------------------------')
      this.validationErrors = {};
      var has_error = false
      if (this.name === '') {
        this.validationErrors['name'] = 'Vui lòng nhập tên nhóm quyền';
        this.$toast.add({
          severity: "error",
          summary: "Thất bại",
          detail: "Vui lòng nhập tên nhóm quyền.",
          life: 10000
        });
        has_error = true
      }else{
        // check có tên trùng không
        let query = '';
        // console.log("dada",this.formMode)
        if(this.formMode == "edit"){
          query = `query MyQuery {
            group_permission(where: {name: {_eq: "`+this.name+`"}, id: {_neq: `+this.group_permission_id+`}}) {
              id
            }
          }`;
        }else{
          query = `query MyQuery {
            group_permission(where: {name: {_eq: "`+this.name+`"}}) {
              id
            }
          }`;
        }
        await this.$apollo.query({
          query: gql(query),
        }).then((res) => {
          // console.log("group_permission",res.data.group_permission)
          if(res.data.group_permission.length > 0){
            this.validationErrors['name'] = 'Tên nhóm quyền đã tồn tại.';
            this.$toast.add({
              severity: "error",
              summary: "Thất bại",
              detail: "Tên nhóm quyền đã tồn tại.",
              life: 10000
            });
            has_error = true;
          }
        })
      }
      
      return has_error
    },
    async analyzeData() {
      // console.log('dâdadadadadadad')
      var data_group_permission = {}
        data_group_permission['name'] = this.name
        var data_item= []
      console.log("this.ListPermission:",this.ListPermission)
    /*  var tests =1;
      if (tests == 1){
        return false;
      }*/
        for (let i = 0; i < this.ListPermission.length; i++) {
          const item = this.ListPermission[i]
          var data_item_item= {}
          data_item_item['permission_id'] = item.id
          data_item_item['view'] = item.view
          data_item_item['list'] = item.list
          data_item_item['add'] = item.add
          data_item_item['edit'] = item.edit
          data_item_item['delete'] = item.delete
          data_item_item['export'] = item.export
          data_item_item['delete_group'] = item.delete_group
          data_item.push(data_item_item)
        }
        var data_group_permission_item = {}
        data_group_permission_item['data'] = data_item
        data_group_permission['group_permission_details'] = data_group_permission_item
        console.log('data insert data_group_permission',data_group_permission)
      return data_group_permission
    },
    async analyzeDataEdit() {
      var data_group_permission = {}
        data_group_permission['name'] = this.name
      return data_group_permission
    },
    async analyzeDataEditItem() {
      var data_item= []
      //console.log("this.ListPermission:",this.ListPermission)
      for (let i = 0; i < this.ListPermission.length; i++) {
          const item = this.ListPermission[i]
          var data_item_item= {}
          data_item_item['group_permission_id'] = this.group_permission_id
          data_item_item['permission_id'] = item.id
          data_item_item['view'] = item.view
          data_item_item['list'] = item.list
          data_item_item['add'] = item.add
          data_item_item['edit'] = item.edit
          data_item_item['delete'] = item.delete
          data_item_item['export'] = item.export
          data_item_item['delete_group'] = item.delete_group
          data_item.push(data_item_item)
        }
      return data_item
    },
    // async getGroupPerId() {
    //   return this.$route.params.id
    // },
    async saveData() {
      if (await this.validateData()) {
        // console.log('true')
        return;
      }
      // console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxx')
      if (this.mode == 'add') {
        // this.$store.commit("setLoading", true);

        var data_group_permission = await this.analyzeData()
       /* var tests =1;
        if (tests == 1){
          return false;
        }*/
        var query = `mutation MyMutation($objects: [group_permission_insert_input!]!) {
            insert_group_permission(objects: $objects) {
              affected_rows
              returning {
                id
                name
              }
            }
          }`;
        console.log("query", query);
        await this.$apollo
          .mutate({
            mutation: gql(query),
            variables: {
              objects: [data_group_permission]
            }
          })
          .then(async (res) => {
            if (res.data[Object.keys(res.data)[0]].affected_rows > 0) {
              this.$toast.add({
                severity: "success",
                summary: "Thành công",
                detail: "Lưu dữ liệu thành công",
                life: 4000
              });
              this.displayDialog = false;
              // var that = this
              setTimeout(function () {
                // that.$store.commit("setLoading", false);
                location.href = '/admin/list-group_permission'
              }, 3000)
            } else {
              // this.$store.commit("setLoading", false);
              this.$toast.add({
                severity: "error",
                summary: "Thất bại",
                detail: "Lưu dữ liệu thất bại",
                life: 3000
              });
            }
          })
      } else {
        let data_group_permission_update = await this.analyzeDataEdit()
        let data_group_permission_item = await this.analyzeDataEditItem()
        /*var tests =1;
        if (tests == 1){
          return false;
        }*/
        // let group_permission_id = await this.getGroupPerId()
        let query = `mutation MyMutation($group_permission_id: Int!, $group_permission_update: group_permission_set_input, $objects: [group_permission_detail_insert_input!]!) {
          update_group_permission(where: {id: {_eq: $group_permission_id}}, _set: $group_permission_update) {
            affected_rows
            returning {
              id
              name
            }
          }
          delete_group_permission_detail(where: {group_permission_id: {_eq: $group_permission_id}}) {
            affected_rows
          }
          insert_group_permission_detail(objects: $objects) {
            affected_rows
          }
        }`;
        console.log('this.group_permission_id', this.group_permission_id)
        await this.$apollo
          .mutate({
            mutation: gql(query),
            variables: {
              group_permission_id: this.group_permission_id,
              group_permission_update: data_group_permission_update,
              objects: data_group_permission_item
            }
          })
          .then(async (res) => {
            if (res.data[Object.keys(res.data)[0]].affected_rows > 0) {
              this.$toast.add({
                severity: "success",
                summary: "Thành công",
                detail: "Lưu dữ liệu thành công",
                life: 4000
              });
              console.log('res',res)
              this.displayDialog = false;
              setTimeout(function () {
                // that.$store.commit("setLoading", false);
                location.href = '/admin/list-group_permission'
              }, 3000)
            } else {
              // this.$store.commit("setLoading", false);
              this.$toast.add({
                severity: "error",
                summary: "Thất bại",
                detail: "Lưu dữ liệu thất bại",
                life: 3000
              });
            }
          })
      }
    },
  },
  apollo: {
    // permission: {
    //   query() {
    //     let query = `
    //       query MyQuery {
    //         permission {
    //           name
    //           id
    //         }
    //       }
    //     `
    //     return gql(query);
    //   },
    //   update(data) {
    //     if(data.permission){
    //       this.ListPermission = data.permission
    //       for (let i = 0; i < this.ListPermission.length; i++) {
    //         const e = this.ListPermission[i];
    //         e.view = false
    //         e.list = false
    //         e.add = false
    //         e.edit = false
    //         e.delete = false
    //         e.export = false
    //       }
    //       console.log('permission', this.ListPermission)
    //     }
    //   },
    //   fetchPolicy: "no-cache",
    //   skip() {
    //     if (this.formMode == "add") {
		// 			return true
		// 		} else {
    //       return false
    //     }
    //   }
    // },
    // group_permission: {
    //   query() {
    //     let query = `
    //       query MyQuery($id: Int) {
    //         group_permission(where: {id: {_eq: $id}}) {
    //           id
    //           name
    //           group_permission_details(order_by: {permission_id: asc}) {
    //             add
    //             delete
    //             edit
    //             export
    //             list
    //             view
    //             permission_id
    //             permission {
    //               name
    //               key
    //             }
    //           }
    //         }
    //       }
    //     `
    //     return gql(query);
    //   },
    //   variables() {
    //     return {
		// 			id: this.$route.params.id
		// 		}
    //   },
    //   update(data) {
    //     if(data.group_permission){
    //       this.ListGroupPer = data.group_permission
    //       console.log('this.ListGroupPer', this.ListGroupPer)
    //       let data_custom = []
    //       if (this.ListGroupPer && this.ListGroupPer[0].group_permission_details) {
    //         for (let i = 0; i < this.ListGroupPer[0].group_permission_details.length; i++) {
    //           const e = this.ListGroupPer[0].group_permission_details[i];
    //           // console.log("EEEEEEEEEEe",e)
    //           e.all = false;
    //           e.add_disabled = false;
    //           e.edit_disabled = false;
    //           e.delete_disabled = false;
    //           e.export_disabled = false;
    //           if(e.permission.key == "insert_document"){
    //             if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true && e.export == true){
    //               e.all = true;
    //             }
    //           }else if(e.permission.key == "list_document"){
    //             if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
    //               e.all = true;
    //             }
    //             e.export_disabled = true;
    //           }else if(e.permission.key == "detail_document"){
    //             if(e.view == true && e.list == true && e.export == true){
    //               e.all = true;
    //             }
    //             e.add_disabled = true;
    //             e.edit_disabled = true;
    //             e.delete_disabled = true;
    //           }else if(e.permission.key == "court_document"){
    //             if(e.view == true && e.list == true && e.export == true){
    //               e.all = true;
    //             }
    //             e.add_disabled = true;
    //             e.edit_disabled = true;
    //             e.delete_disabled = true;
    //           }else if(e.permission.key == "confirm_salary_document"){
    //             if(e.view == true && e.list == true){
    //               e.all = true;
    //             }
    //             e.add_disabled = true;
    //             e.edit_disabled = true;
    //             e.delete_disabled = true;
    //             e.export_disabled = true;
    //           }else if(e.permission.key == "list_document_province"){
    //             if(e.view == true && e.list == true && e.add == true && e.edit == true){
    //               e.all = true;
    //             }
    //             e.delete_disabled = true;
    //             e.export_disabled = true;
    //           }else if(e.permission.key == "employee_payroll"){
    //             if(e.view == true && e.list == true && e.export == true){
    //               e.all = true;
    //             }
    //             e.add_disabled = true;
    //             e.edit_disabled = true;
    //             e.delete_disabled = true;
    //           }else if(e.permission.key == "organ_pricelist"){
    //             if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
    //               e.all = true;
    //             }
    //             e.export_disabled = true;
    //           }else if(e.permission.key == "organ_pricelist_province"){
    //             if(e.view == true && e.list == true  && e.edit == true){
    //               e.all = true;
    //             }
    //             e.add_disabled = true;
    //             e.delete_disabled = true;
    //             e.export_disabled = true;
    //           }else if(e.permission.key == "salary_pricelist"){
    //             if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
    //               e.all = true;
    //             }
    //             e.export_disabled = true;
    //           }else if(e.permission.key == "salary_pricelist_province"){
    //             if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
    //               e.all = true;
    //             }
    //             e.export_disabled = true;
    //           }else if(e.permission.key == "holiday_setting"){
    //             if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
    //               e.all = true;
    //             }
    //             e.export_disabled = true;
    //           }else if(e.permission.key == "delay_document_setting"){
    //             if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
    //               e.all = true;
    //             }
    //             e.export_disabled = true;
    //           }else if(e.permission.key == "report_late_done"){
    //             if(e.view == true && e.list == true && e.export == true){
    //               e.all = true;
    //             }
    //             e.add_disabled = true;
    //             e.edit_disabled = true;
    //             e.delete_disabled = true;
    //           }else if(e.permission.key == "report_late_undone"){
    //             if(e.view == true && e.list == true && e.export == true){
    //               e.all = true;
    //             }
    //             e.add_disabled = true;
    //             e.edit_disabled = true;
    //             e.delete_disabled = true;
    //           }else if(e.permission.key == "report_compare"){
    //             if(e.view == true && e.list == true && e.export == true){
    //               e.all = true;
    //             }
    //             e.add_disabled = true;
    //             e.edit_disabled = true;
    //             e.delete_disabled = true;
    //           }else if(e.permission.key == "push_notification"){
    //             if(e.view == true && e.list == true && e.add == true){
    //               e.all = true;
    //             }
    //             e.edit_disabled = true;
    //             e.delete_disabled = true;
    //             e.export_disabled = true;
    //           }else if(e.permission.key == "list_coordinator"){
    //             if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
    //               e.all = true;
    //             }
    //             e.export_disabled = true;
    //           }else if(e.permission.key == "list_circulator"){
    //             if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
    //               e.all = true;
    //             }
    //             e.export_disabled = true;
    //           }else if(e.permission.key == "list_office"){
    //             if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
    //               e.all = true;
    //             }
    //             e.export_disabled = true;
    //           }else if(e.permission.key == "list_area"){
    //             if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
    //               e.all = true;
    //             }
    //             e.export_disabled = true;
    //           }else if(e.permission.key == "list_organization"){
    //             if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
    //               e.all = true;
    //             }
    //             e.export_disabled = true;
    //           }else if(e.permission.key == "list_affiliate_office"){
    //             if(e.view == true && e.list == true && e.add == true && e.edit == true && e.delete == true){
    //               e.all = true;
    //             }
    //             e.export_disabled = true;
    //           }
    //           e.name = e.permission.name
    //           e.id = e.permission_id
    //           data_custom.push(e);
    //           // this.ListPermission[i] = {}
    //           // this.ListPermission[i].view = e.view
    //           // this.ListPermission[i].list = e.list
    //           // this.ListPermission[i].add = e.add
    //           // this.ListPermission[i].edit = e.edit
    //           // this.ListPermission[i].delete = e.delete
    //           // this.ListPermission[i].export = e.export
    //           // this.ListPermission[i].name = e.permission.name
    //           // this.ListPermission[i].id = e.permission_id
    //           // this.ListPermission[i].all = e.all
    //           // this.ListPermission[i].add_disabled = e.add_disabled
    //           // this.ListPermission[i].edit_disabled = e.edit_disabled
    //           // this.ListPermission[i].delete_disabled = e.delete_disabled
    //           // this.ListPermission[i].export_disabled = e.export_disabled
    //         }
    //       }
    //       this.ListPermission = data_custom
    //       this.name = this.ListGroupPer[0].name
    //       console.log('permission', this.ListPermission)
    //     }
    //   },
    //   fetchPolicy: "no-cache",
    //   skip() {
    //     // return !this.$route.params.id
    //     if (this.formMode == "edit") {
		// 			return true
		// 		} else {
    //       return false
    //     }
    //   }
    // },
  }
}
</script>

<style lang="scss">
  .p-multiselect {
    width: 450px;
  }
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: .25rem;
    padding-bottom: .25rem;
    
  }
  .category-item-value {
    padding: .25rem .5rem;
    border-radius: 3px;
    display: inline-flex;
    margin-right: .2rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
  .p-multiselect-label-container{
    height: 40px;
  }
  
  </style>
